export class FinalizeOrderDto {
    public orderId: number;
    public boxTexts: string[];
    public slotText: string[];
}
